export const routeV1 = {
  // 메인
  default: "/",

  // 제품
  products: "/products",

  // 서비스
  service: "/service",

  //회사소개
  introduce: "/introduce",
  overview: "/introduce/overview",
  history: "/introduce/history",
  heritage: "/introduce/major-performance/heritage",
  workspace: "/introduce/workspace",
  direction: "/introduce/direction",
  tel: "/introduce/direction#tel",

  //투자
  investment: "/investment",
  electronicAnnounce: "/investment/electronic-announcement",
  ir_info: "/investment/ir-info",
  ir_info_detail: "/investment/ir-info/detail",
  managementInfo: "/investment/management-info",
  managementInfoDetail: "/investment/management-info/detail",
  dart: "https://dart.fss.or.kr/html/search/SearchCompany_M2.html?textCrpNM=%EB%A3%A8%EB%AF%B8%EB%A5%B4",

  //cyber_relation
  cyber_relation: "/cyber-relation",
  newArticle: "/cyber-relation/new-article",
  lumirNews: "/cyber-relation/lumir-news",
  lumirNewsDetail: "/cyber-relation/lumir-news-detail",

  //public-relations-office
  publicRelationsOffice: "/cyber-relation/public-relations-office",
  brochure: "/cyber-relation/public-relations-office/brochure",
  videoGallery: "/cyber-relation/public-relations-office/video-gallery",

  //recruit
  recruit: "/recruit",
  apply: "/recruit/apply",
  applySuccess: "/recruit/apply/success",
  applyFailed: "/recruit/apply/failed",

  talentType: "/recruit/talent-type",
  jobAnnounce: "/recruit/job-announcement",
  jobAnnounceDetail: "/recruit/job-announcement/detail",
  jobAnnounceSaramin:
    "https://www.saramin.co.kr/zf_user/company-info/view-inner-recruit?csn=clE1WEZscDVaeGZJb2JLU2NOTlRpQT09",

  // 공통
  notFound: "/404",
};
